import { render, staticRenderFns } from "./teenagerPhysicianVisits.vue?vue&type=template&id=cef906f0&scoped=true&"
import script from "./teenagerPhysicianVisits.vue?vue&type=script&lang=js&"
export * from "./teenagerPhysicianVisits.vue?vue&type=script&lang=js&"
import style0 from "./teenagerPhysicianVisits.vue?vue&type=style&index=0&id=cef906f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef906f0",
  null
  
)

export default component.exports